import { render, staticRenderFns } from "./bookingsFilters.vue?vue&type=template&id=5323a041&scoped=true&"
import script from "./bookingsFilters.vue?vue&type=script&lang=ts&"
export * from "./bookingsFilters.vue?vue&type=script&lang=ts&"
import style0 from "./bookingsFilters.vue?vue&type=style&index=0&id=5323a041&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323a041",
  null
  
)

export default component.exports